<template>
  <div class="ingreso-egreso-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información del Ingreso/Egreso">
          <b-table 
              small 
              class="datos-objeto" 
              responsive="sm" 
              :items="ingresoEgresoDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Efectivo" v-if="ingresoEgresoDocumentos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="ingresoEgresoDocumentos" 
              :fields="documentosFields">
            <template v-slot:cell(documentoNumero)="data">
              {{ data.item.documentoNumero }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Depósitos" v-if="ingresoEgresoDepositos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="ingresoEgresoDepositos" 
              :fields="depositosFields">
            <template v-slot:cell(fechaCreditoDebito)="data">
              {{ data.item.fechaCreditoDebito | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Transferencias" v-if="ingresoEgresoTransferencias.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="ingresoEgresoTransferencias" 
              :fields="transferenciasFields">
            <template v-slot:cell(fechaCreditoDebito)="data">
              {{ data.item.fechaCreditoDebito | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Descuento del Adelanto" v-if="ingresoEgresoCuotasDatos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes cuotas"
              :items="ingresoEgresoCuotasDatos" 
              :fields="cuotasFields">
            <template v-slot:cell(periodo)="data">
              {{ data.item.periodo | periodo }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'ingresoegreso/getField',
  mutationType: 'ingresoegreso/updateField',
});

export default {
  name: 'IngresoEgresoDatos',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal, 
  ],
  data: () => {
    return {
      ingresoEgresoId: 0,

      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      documentosFields: [
        { 
          key: 'documentoTipo',
          label: 'Moneda'
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],

      depositosFields: [
        { 
          key: 'fechaCreditoDebito',
          label: 'Fecha Pago' 
        },
        { 
          key: 'bancoCuenta',
          label: 'Cuenta'
        },
        {
          key: 'importe',
          class: 'text-right',
        },
      ],

      transferenciasFields: [
        { 
          key: 'fechaCreditoDebito',
          label: 'Fecha Cred./Deb.' 
        },
        { 
          key: 'bancoCuenta',
          label: 'Cuenta'
        },
        {
          key: 'importe',
          class: 'text-right',
        },
      ],

      cuotasFields: [
        { 
          key: 'periodo',
        },
        { key: 'importe' },
      ],
    }
  },
  computed: {
    ...mapFields([
      'ingresoEgresoDatos',
      'ingresoEgresoCuotasDatos',
      'ingresoEgresoDocumentos',
      'ingresoEgresoDepositos',
      'ingresoEgresoTransferencias',
    ]),
  },
  created() {
    this.ingresoEgresoId = this.$route.params.id;

    this.$store.dispatch('ingresoegreso/getDatos', this.ingresoEgresoId)
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style>
  .ingreso-egreso-datos .registro-ordenes.cuotas table td[aria-colindex="1"] {
    width: 40%;
  }
  .ingreso-egreso-datos .registro-ordenes.cuotas table td[aria-colindex="2"] {
    width: 60%;
  }
</style>